import { formatRiskCell } from 'tools/helper'
import { Tooltip } from 'components'
import strings from 'strings'
import { numberComparator, numberOrStringComparator } from 'tools/comparators'
import { GridRenderCellParams } from '@mui/x-data-grid'

const t = strings.TABLE_DEFAULTS

const getDriverListTableColumns = (useKilometers: boolean = false) => {
  const distanceLabel = useKilometers ? 'Kilometers' : 'Miles'
  return [
    {
      field: 'rowId',
      headerName: 'ID',
      width: 60,
      minWidth: 60,
      flex: 0.5,
    },
    {
      field: 'eldDriverId',
      headerName: 'Driver ID',
      width: 120,
      minWidth: 120,
      flex: 1,
      sortable: true,
      sortComparator: numberOrStringComparator,
      renderCell: function (params: GridRenderCellParams) {
        return (
          <Tooltip title={params.value} containerClassName="ellipsis">
            {params.value}
          </Tooltip>
        )
      },
    },
    {
      field: 'driverName',
      headerName: 'Driver Name',
      width: 180,
      minWidth: 180,
      flex: 1.5,
      renderCell: function (params: GridRenderCellParams) {
        return (
          <Tooltip title={params.value} containerClassName="ellipsis">
            {params.value}
          </Tooltip>
        )
      },
    },
    {
      field: 'licenseNo',
      headerName: 'License Number',
      width: 140,
      minWidth: 140,
      flex: 1.2,
      renderCell: function (params: GridRenderCellParams) {
        return (
          <Tooltip title={params.value} containerClassName="ellipsis">
            {params.value}
          </Tooltip>
        )
      },
    },
    {
      field: 'email',
      headerName: 'Email',
      width: 220,
      minWidth: 220,
      flex: 2,
      renderCell: function (params: GridRenderCellParams) {
        return (
          <Tooltip title={params.value} containerClassName="ellipsis">
            {params.value}
          </Tooltip>
        )
      },
    },
    {
      field: 'miles',
      headerName: `${distanceLabel} (Last 30 Days)`,
      width: 120,
      minWidth: 120,
      flex: 1,
      sortable: true,
      sortComparator: numberComparator,
      valueGetter: (value: any, row: any) => {
        return row.miles !== undefined && row.miles !== null
          ? formatRiskCell(row.miles)
          : t.DASH_VALUE
      },
    },
    {
      field: 'lastKnownVehicle',
      headerName: 'Last Known Vehicle',
      width: 200,
      minWidth: 200,
      flex: 1.8,
      renderCell: function (params: GridRenderCellParams) {
        return (
          <Tooltip title={params.value} containerClassName="ellipsis">
            {params.value}
          </Tooltip>
        )
      },
    },
  ]
}

export { getDriverListTableColumns }
